import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Fab, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { CertainThemeEditor } from '../certainThemeEditor';
import { ThemeList as ThemeListForMultiSelect } from '../themeList';
import { updateThemesBunch } from 'api/admin/businesses/businesses';
import { BUTTONS, THEME_MESSAGES } from 'utils/constants';

export const ThemeContainer = ({
  initialEditableCertainTheme,
  setInitialEditableCertainTheme,
  businessId,
  selectedStores,
  refreshStoreAndBusiness,
  setSelectedStores,
  setLoading,
  businessThemeLink
}) => {
  const [isThemeListOpened, setIsThemeListOpened] = useState(false);
  const [themeToBunch, setThemeToBunch] = useState(null);

  const [requestResponse, setRequestResponse] = useState('');
  const [requestError, setRequestError] = useState('');
  const closeSnackbar = () => {
    setRequestError('');
    setRequestResponse('');
  };
  const snackbarMessage = requestResponse || requestError;

  const openThemeBunchEditor = () => {
    setIsThemeListOpened(true);
  };

  const resetState = async () => {
    setThemeToBunch(null);
    setSelectedStores([]);
    setLoading(false);
    await refreshStoreAndBusiness();
  };

  useEffect(() => {
    const updateBunch = async () => {
      setLoading(true);
      try {
        const { primaryColor, logoUrl, borderRadius } = themeToBunch;
        await updateThemesBunch({
          storeThemeIds: selectedStores.map((store) => store?.theme?.id),
          primaryColor,
          logoUrl,
          borderRadius,
        });
        setRequestResponse(`${selectedStores.map((store) => store.name).join(', ')} were updated`);
        await resetState();
      } catch (e) {
        setRequestResponse(THEME_MESSAGES.somethingWrong);
        await resetState();
      }
    };

    if (themeToBunch) {
      updateBunch();
    }
  }, [themeToBunch]);

  return (
    <div className="theme-container">
      <CertainThemeEditor
        initialEditableCertainTheme={initialEditableCertainTheme}
        setInitialEditableCertainTheme={setInitialEditableCertainTheme}
        refreshStoreAndBusiness={refreshStoreAndBusiness}
        businessId={businessId}
        businessThemeLink={businessThemeLink}
        setRequestResponse={setRequestResponse}
        setRequestError={setRequestError}
      />
      <ThemeListForMultiSelect
        setThemeFromList={setThemeToBunch}
        isThemeListOpened={isThemeListOpened}
        setIsThemeListOpened={setIsThemeListOpened}
        businessId={businessId}
        refreshStoreAndBusiness={refreshStoreAndBusiness}
        setRequestResponse={setRequestResponse}
        setRequestError={setRequestError}
      />

      {selectedStores.length ? (
        <Fab
          variant="extended"
          color="primary"
          classes={{ root: 'theme-fab' }}
          onClick={openThemeBunchEditor}
        >
          {BUTTONS.setTheme}
        </Fab>
      ) : null}

      <Snackbar open={Boolean(snackbarMessage)} autoHideDuration={3000} onClose={closeSnackbar}>
        <MuiAlert elevation={6} variant="filled" severity={requestError ? 'error' : 'success'}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

ThemeContainer.propTypes = {
  initialEditableCertainTheme: PropTypes.object,
  setInitialEditableCertainTheme: PropTypes.func.isRequired,
  businessId: PropTypes.string.isRequired,
  selectedStores: PropTypes.array,
  refreshStoreAndBusiness: PropTypes.func.isRequired,
  setSelectedStores: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};
